import { defineMessages } from 'react-intl'

export default defineMessages({
    selectCoupons: {
        defaultMessage: 'Selecciona los cupones',
    },
    coupons: {
        defaultMessage: 'Cupones',
    },
})
